import { Column, IntegratedSorting, SortingState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { StyledSpinner } from "modules/reservationDetail/styles";
import { memo, useMemo } from "react";
import { BillingReportHeader, BillingReportRow } from "../application/BillingReport.service";

export interface BillingTableProps {
  isLoading: boolean;
  headers: BillingReportHeader[];
  rows: BillingReportRow[];
}

function _BillingTable({ isLoading, headers, rows }: BillingTableProps) {
  const columns: Column[] = useMemo(
    () =>
      headers.map((header, headerIdx) => ({
        name: header.name,
        title: header.title,
        getCellValue: (row: BillingReportRow) => row[headerIdx].value,
      })),
    [headers]
  );

  return (
    <>
      {isLoading ? (
        <StyledSpinner className="fa fa-spinner fa-spin" />
      ) : (
        <Grid rows={rows} columns={columns}>
          <SortingState defaultSorting={[{ columnName: "invoiceNumber", direction: "asc" }]} />
          <IntegratedSorting />
          <Table />
          <TableHeaderRow showSortingControls />
        </Grid>
      )}
    </>
  );
}

export const BillingTable = memo(_BillingTable);
